const config = require('../../config/config');

const servicesSettings = config.services;

const basePath = `${servicesSettings.MG_PROTOCOL}://${servicesSettings.MG_DOMAIN}:${servicesSettings.MG_PORT}${servicesSettings.MG_SERVICES_BASE}`;

/**
 * Throw response if invalid status code
 * @param  {[type]} response [description]
 * @return {[type]}          [description]
 */
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  throw response;
}

/**
 * Transform response to json
 * @param  {[type]} response [description]
 * @return {[type]}          [description]
 */
function parseJSON(response) {
  return response.json();
}

module.exports = {
  all(offset, limit, filter, company) {
    const params = [];

    if (offset) {
      params.push(`offset=${offset}`);
    }

    if (limit) {
      params.push(`limit=${limit}`);
    }

    if (company) {
      params.push(`company=${company}`);
    }

    return fetch(
      `${basePath}reservations?${params.join('&')}`
    ).then(
      checkStatus
    ).then((response) => {
      const total = response.headers.get('X-Total-Count');

      return response.json().then((reservations) => {
        return [reservations, total];
      });
    });
  },
  getById(id) {
    return fetch(`${basePath}reservations/${id}`)
      .then(checkStatus)
      .then(parseJSON);
  },
  downloadExport(company = '') {
    fetch(
      `${basePath}reservations/csv?company=${company}`
    ).then((response) => {
      return response.blob();
    }).then((response) => {
      const blob = new Blob([response], {type: 'application/csv'});
      const downloadUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = 'reservasjoner.csv';
      document.body.appendChild(a);
      a.click();
    });
  }
};
